<template>
  <div class="footer-menu">
    <slot />
  </div>
</template>

<style lang="scss">
@import "../scss/importall.scss";

.footer-menu {
  @extend %text;
  display: flex;
  margin-left: -1rem;

  .footer-menu-link {
    color: inherit;
    text-decoration: none;
    display: flex;
    margin: 0 0.75rem;
    position: relative;

    &:before {
      content: "•";
      position: absolute;
      left: -1rem;
    }

    &:first-child:before {
      content: "";
    }

    &:nth-child(2):before {
      color: #4c4fe1;
    }

    &:nth-child(3):before {
      color: #ff6f6c;
    }

    &:nth-child(4):before {
      color: #44c4af;
    }

    span {
      transition: all 0.15s ease-in-out;
    }

    &:hover span {
      opacity: 0.7;
    }
  }
}
</style>
